export default __webpack_public_path__ + "images/379d49cec1588ff79a651d496c73fa9b-halloweenhaunt_small.webp";